export default class DeliveryTypeModel {
  constructor(obj) {
    obj = obj || {};
    this.id = obj.id;
    this.description = obj.description;
  }
}